/** Тексты этапа 1.1: вход, виджет «Идея / Проблема», уведомления, пользователи, журнал. Паритет с en/extra.ts — npm run i18n:check. */
export default {
  ui: {
    loading: 'Загрузка…',
    error: 'Что-то пошло не так',
    retry: 'Повторить',
    empty: 'Пока пусто',
    saving: 'Сохраняем…',
    saved: 'Сохранено',
    copy: 'Скопировать',
    copied: 'Скопировано',
    never: 'Никогда',
  },
  auth: {
    google: 'Войти через Google',
    or: 'или',
    accessByInvite: 'Доступ по приглашению. Обратитесь к менеджеру Treejar.',
    staffHint: 'Сотрудники Treejar входят здесь же и попадают в Partner Hub.',
    inviteTitle: 'Задайте пароль',
    inviteBody: 'Вас пригласили с ролью {{role}}{{partner}}. Придумайте пароль для {{email}}.',
    inviteBodyPartner: ' в {{partner}}',
    resetTitle: 'Новый пароль',
    resetBody: 'Придумайте новый пароль для {{email}}.',
    name: 'Ваше имя',
    newPassword: 'Новый пароль',
    confirmPassword: 'Повторите пароль',
    passwordRule: 'Не меньше 8 символов.',
    passwordMismatch: 'Пароли не совпадают.',
    activate: 'Задать пароль и войти',
    forgotTitle: 'Сброс пароля',
    forgotBody: 'Введите рабочую почту — если она зарегистрирована, мы пришлём ссылку для нового пароля.',
    forgotSubmit: 'Отправить ссылку',
    forgotSent: 'Если {{email}} зарегистрирован, ссылка для сброса уже отправлена. Проверьте почту.',
    signOut: 'Выйти',
    errors: {
      invalid_credentials: 'Почта или пароль не распознаны. Проверьте данные или сбросьте пароль.',
      user_disabled: 'Учётная запись отключена. Обратитесь к менеджеру Treejar.',
      not_invited: 'Доступ по приглашению. Попросите менеджера Treejar пригласить {{email}}.',
      state: 'Сессия входа устарела, попробуйте ещё раз.',
      email: 'Google не подтвердил адрес почты.',
      invite_invalid: 'Ссылка недействительна или устарела. Запросите новое приглашение.',
      password_weak: 'Пароль должен быть не короче 8 символов.',
      network: 'Сервер недоступен. Проверьте соединение и попробуйте снова.',
      google_not_configured: 'Вход через Google ещё не настроен.',
      redirect_uri_mismatch: 'В Google OAuth не добавлен адрес возврата этого сайта.',
      session_invalid: 'Сессия истекла, войдите снова.',
      generic: 'Ошибка входа: {{code}}',
    },
  },
  fb: {
    button: 'Идея / Проблема',
    title: 'Идея / Проблема',
    close: 'Закрыть',
    kind: { bug: 'Проблема', net: 'Не хватает', mesh: 'Мешает', idea: 'Идея', feat: 'Функция' },
    placeholderBug: 'Что произошло, что ожидали и что увидели',
    placeholderIdea: 'Опишите, что хотелось бы изменить или добавить',
    attachShot: 'Приложить снимок этого экрана',
    orFile: 'или свой файл:',
    screen: 'Экран: {{screen}}',
    capturing: 'Снимаем экран…',
    sending: 'Отправка…',
    send: 'Отправить',
    thanks: 'Спасибо! Замечание №{{id}} принято.',
    thanksHint: 'Ответим в карточке замечания; об исправлении придёт уведомление.',
    myItems: 'Мои замечания',
    failed: 'Не удалось отправить. Попробуйте ещё раз.',
    myTitle: 'Мои замечания',
    mySubtitle: 'Идеи и проблемы, которые вы отправили, и их статус. Исправленное можно принять или вернуть в работу с комментарием.',
    boardHint: 'Статусы: запрос на исправление → в работе → исправлено (ждёт вашей проверки) → принято. Исправленное принимает автор кнопкой «Принять» или возвращает в работу с комментарием.',
    filter: { open: 'открытые', awaiting: 'ждут проверки', closed: 'закрытые', all: 'все' },
    onlyMine: 'только мои',
    sideAll: 'Treejar и партнёры',
    sideTreejar: 'Treejar',
    sidePartner: 'Партнёр',
    col: { status: 'Статус', type: 'Тип', summary: 'Суть', screen: 'Экран', author: 'Автор', when: 'Когда', side: 'Сторона', priority: 'Приоритет' },
    empty: 'Замечаний в этом фильтре нет',
    selectHint: 'Выберите замечание слева',
    comments: '{{n}} комм.',
    robot: 'робот: {{state}}',
    note: 'Заметка администратора',
    robotNote: 'Робот',
    history: 'История',
    commentPlaceholder: 'Комментарий или вопрос',
    sendComment: 'Отправить комментарий',
    accept: 'Принять',
    returnToWork: 'Вернуть в работу',
    status: { new: 'Запрос на исправление', work: 'В работе', testing: 'Исправлено', done: 'Принято', reject: 'Отклонено' },
    priority: { low: 'низкий', normal: 'обычный', high: 'высокий', critical: 'критический' },
    runFix: 'Запустить исправление',
    runFixHint: 'Робот на сервере возьмёт замечание, исправит код, выложит и отчитается',
    queued: 'В очереди робота',
    running: 'Робот работает…',
    createIssue: 'Создать задачу',
    issueCreated: 'Задача в GitHub создана',
    screenshot: 'снимок экрана',
    system: 'система',
    eventStatus: 'статус {{from}} → {{to}}',
    eventPriority: 'приоритет {{from}} → {{to}}',
    eventFix: 'робот: {{state}}',
    eventIssue: 'создана задача в GitHub',
    eventComment: 'комментарий',
    kindsHint: 'Типы: {{kinds}}',
  },
  bell: {
    filterOther: 'Другое',
    loadError: 'Не удалось загрузить уведомления',
  },
  users: {
    inviteTitle: 'Пригласить сотрудника Treejar',
    inviteSub: 'Он получит письмо со ссылкой для пароля; также можно войти через Google с этим адресом.',
    email: 'Рабочая почта',
    name: 'Имя и фамилия',
    role: 'Роль',
    locale: 'Язык письма',
    send: 'Отправить приглашение',
    sent: 'Приглашение отправлено на {{email}}',
    inviteLink: 'Ссылка-приглашение (если письмо не дошло):',
    reinvite: 'Отправить приглашение ещё раз',
    disable: 'Отключить',
    enable: 'Включить',
    approveMargin: 'Согласует продажи ниже минимальной маржи',
    approveLoss: 'Согласует убыточные сделки',
    statusDisabled: 'Отключён',
    you: 'вы',
    roleFinance: 'Финансы',
  },
  audit: {
    title: 'Журнал операций',
    sub: 'Журнал только на добавление: входы, приглашения, настройки и изменения данных. Записи нельзя править и удалять.',
    when: 'Когда',
    who: 'Кто',
    side: 'Сторона',
    entity: 'Объект',
    action: 'Действие',
    details: 'Подробности',
    filterEntity: 'Объект',
    filterActor: 'Кто',
    empty: 'Записей нет',
    sideTreejar: 'Treejar',
    sidePartner: 'Партнёр',
    sideSystem: 'Система',
  },
  impX: {
    pagesHint: '{{count}} стр.',
    rowsHint: '{{count}} строк',
    profile: 'Профиль импорта',
    profileGeneric: 'Общий режим (без профиля)',
    profileHint: 'Действуют правила партнёра: смысл двух цен, разделы спецпредложений, общие ячейки стока.',
    genericHint: 'Извлекаются только явные поля; каждую строку нужно проверить вручную.',
    contractMissing: 'Договор не действует ({{status}}) — публикация будет заблокирована',
    uploading: 'Загрузка…',
    prevMeta: 'v{{version}} · {{date}}',
    prevItems: '{{count}} позиций',
    noPrev: 'У партнёра ещё нет опубликованного прайса.',
    draftsAllTitle: 'Незавершённые импорты',
    draftsAllSub: 'Черновики всех поставщиков: продолжите проверку или публикацию.',
    historySub: 'Опубликованные и заменённые версии прайсов всех поставщиков.',
    historyEmpty: 'Загрузок ещё не было.',
    openVersion: 'Открыть',
    draftsTitle: 'Незавершённые импорты этого партнёра',
    hasErrors: 'с ошибками',
    continueReview: 'Продолжить проверку',
    continueExtraction: 'Открыть извлечение',
    uploadError: { bad_file_type: 'Неподдерживаемый тип файла. Нужен PDF, XLSX, CSV, JPG или PNG.', file_too_large: 'Файл больше 40 МБ.', profile_mismatch: 'Этот профиль принадлежит другому партнёру.', network: 'Сервер недоступен.' },
    statRisk: 'Риск, AED',
    retryExtraction: 'Запустить извлечение ещё раз',
    pageFailed: 'не прочитана',
    modeLabel: 'Режим',
    mode: { profile: 'Профиль партнёра', generic: 'Общий', table: 'Таблица (без ИИ)' },
    modelLabel: 'Модель',
    costLabel: 'Стоимость',
    pendingBanner: 'Ещё {{count}} строк требуют ручной проверки · суммарный риск AED {{risk}}',
    allReviewed: 'Все обязательные строки проверены.',
    showPending: 'Показать непроверенные',
    reviewAll: 'Проверено: строки без замечаний',
    reviewAllHint: 'Поставит «Проверено» строкам без флагов проверок, с уверенностью распознавания от 85 % и риском ниже порога. Строки с замечаниями останутся на ручную проверку.',
    reviewForce: 'Отметить все {{count}} проверенными (admin)',
    reviewForceHint: 'Отмечает и обязательные строки без сверки — для доверенного прайса или проверки пути. Действие попадает в журнал.',
    reviewMarked: 'Отмечено проверенными: {{count}}. Осталось вручную: {{pending}}.',
    reviewRuleNote: 'Без замечаний = нет флагов проверок, уверенность ≥ 85 %, риск ниже порога из настроек. Жёлтые строки подтвердите сами: откройте позицию и нажмите «Отметить проверенной».',
    includeHint: 'Включить в публикацию',
    colRisk: 'Риск, AED',
    colFlags: 'Проверки',
    colReviewed: 'Проверено',
    required: 'обязательно',
    optional: 'по желанию',
    edited: 'правка',
    special: 'спец.',
    discontinued: 'снято',
    setPrice: 'задать цену',
    compare: 'Сравнить с каталогом',
    flag: {
      price_invalid: 'нет цены', price_jump: 'скачок цены >20%', price_outlier: 'цена вне диапазона', pass_mismatch: 'проходы разошлись', qty_invalid: 'плохое количество', pool_inconsistent: 'общий сток расходится',
      option_suspicious: 'доплата >50%', discount_conflict: 'скидка ≠ договору', duplicate_conflict: 'дубль расходится', two_prices: 'две цены — укажите', no_cbm: 'нет CBM', new_item: 'новая позиция',
    },
    diffTitle: 'Изменения относительно текущего каталога (v{{version}})',
    publishSub: 'Обновятся товары, партии стока и цены; выставленные спецификации, резервы и PO сохранят свои снимки.',
    blockersTitle: 'Публикация заблокирована, пока:',
    blockContract: 'договор партнёра не подписан или не действует',
    blockReview: 'не проверены {{count}} обязательных строк',
    blockPrice: 'у {{count}} строк нет цены',
    blockApproval: 'admin не согласовал версию (суммарный риск AED {{risk}} ≥ порога второго согласования)',
    approveBtn: 'Согласовать как admin',
    approved: 'Второе согласование получено от admin.',
    confirmNote: 'Предыдущая версия станет Superseded. Существующие КП, резервы и заказы поставщикам сохранят свои цены.',
    doneBody: '{{count}} позиций {{partner}} теперь в каталоге: новых {{added}}, снято {{removed}}, изменений цены или стока {{changed}}. Спецификации, выставленные до сегодняшнего дня, сохраняют свои цены.',
    statStockUnits: 'Единиц на складе',
    publishError: { review_pending: 'Не все обязательные строки проверены.', missing_price: 'У части строк нет цены.', second_approval_required: 'Сначала версию должен согласовать admin.', contract_required: 'Договор партнёра не действует.', not_draft: 'Эта версия уже опубликована.' },
  },
  perm: {
    title: 'Что каждая роль открывает и меняет',
    sub: 'Пять ролей остаются, а администратор по каждому разделу решает: роль ничего не видит, только смотрит или редактирует. Проверка идёт на сервере и в базе — экран лишь скрывает пункты меню и кнопки. У администратора всегда всё, его ограничить нельзя.',
    save: 'Сохранить права',
    reset: 'Вернуть по умолчанию',
    saved: 'Права ролей сохранены',
    readOnlyNote: 'Менять матрицу может только администратор. Вы видите её для справки.',
    adminLocked: 'У администратора всегда полный доступ',
    colArea: 'Раздел',
    colAction: 'Действие',
    level: { none: 'Нет доступа', read: 'Просмотр', write: 'Изменение' },
    area: { dashboard: 'Дашборд', partners: 'Поставщики', import: 'Импорт прайсов', catalog: 'Каталог', specifications: 'Спецификации', purchase_orders: 'Заказы', feedback: 'Замечания', settings: 'Настройки', users: 'Пользователи' },
    areaHint: {
      dashboard: 'Главный экран со сводными цифрами',
      partners: 'Карточки поставщиков, онбординг, превью, договоры, разбор сайта',
      import: 'Загрузка и проверка прайс-листов',
      catalog: 'Товары и карточки для сайта',
      specifications: 'Спецификации клиентов',
      purchase_orders: 'Заказы поставщикам из Zoho',
      feedback: 'Доска «Идея / Проблема»',
      settings: 'Настройки хаба и интеграция с сайтом; «Изменение» позволяет их менять',
      users: 'Список сотрудников; «Изменение» позволяет приглашать, менять роли и отключать',
    },
    actionsTitle: 'Отдельные действия',
    actionsSub: 'Ответственные шаги, которые разрешаются поверх доступа к разделам. Роли нужен ещё и уровень «Изменение» в соответствующем разделе.',
    action: { publish_prices: 'Опубликовать прайс-лист', second_approval: 'Согласовать прайс с высоким риском', send_to_site: 'Отправить карточки на сайт', sign_contracts: 'Отправлять и подписывать договоры', zoho_sync: 'Запускать синхронизацию Zoho' },
    actionHint: {
      publish_prices: 'Проверенный черновик становится действующим прайсом поставщика',
      second_approval: 'Вторая подпись, когда суммарный риск выше порога из «Правил цен»',
      send_to_site: 'Публикация, архив и передача наличия на treejartrading.ae',
      sign_contracts: 'Отправить договор поставщику, подписать, загрузить скан',
      zoho_sync: 'Подтянуть заказы из Zoho Books по кнопке',
    },
    howTitle: 'Как дать доступ сотруднику',
    how1: '«Пользователи и роли» → «Пригласить»: укажите Google-почту, которой человек входит, и выберите роль.',
    how2: 'Человек открывает market.starec.ai → «Войти через Google» с этой почтой. Пароль не нужен.',
    how3: 'Здесь вы решаете, что эта роль видит и меняет. Изменения действуют со следующего запроса, перелогиниваться не нужно.',
    openMatrix: 'Открыть матрицу прав',
    googleHint: 'Вход по Google-аккаунту: приглашённая почта должна совпадать с Google-почтой буква в букву.',
    noAccessTitle: 'Нет доступа к разделу',
    noAccessBody: 'В вашей роли этого раздела нет. Попросите администратора изменить это в Настройки → «Права ролей».',
  },
  sp: {
    belowMinResale: 'Цена ниже минимальной цены перепродажи партнёра — отклонено базой данных, согласованием это не обходится',
    blocked: 'Заблокировано: {{list}}',
    blocker: {
      no_lines: 'нет строк',
      no_price: 'у строки нет цены',
      approval_below_min: 'маржа или вклад ниже порога — нужно согласование',
      approval_loss: 'вклад отрицательный — нужно согласование убытка',
      no_cbm: 'есть позиции без CBM — внесите самовывоз и доставку вручную',
    },
    lineAdded: '{{sku}} добавлен',
    go: { Draft: 'Вернуть в черновик', Quoted: 'Отправить КП', Won: 'Выиграна', Lost: 'Проиграна', Cancelled: 'Отменить' },
    quoteValid: 'КП действует до {{date}}',
    repriced: 'Пересчитано по текущему прайсу',
    reprice: 'Пересчитать по текущему прайсу',
    repriceHint: 'У отправленных КП себестоимость и цены — снимки; это действие заменяет их текущим прайсом и пишется в журнал.',
    statusChanged: 'Статус: {{status}}',
    lockedNote: 'Спецификация закрыта — строки и цены только для чтения.',
    frozenNote: 'КП отправлено: снимки себестоимости и цен заморожены. Новый прайс их не меняет — есть «Пересчитать по текущему прайсу».',
    siteAddress: 'Адрес объекта',
    quickAddSku: 'Добавить по SKU',
    add: 'Добавить',
    colContribution: 'Вклад',
    noCbmTag: 'нет CBM',
    priceBasis: { old_stock: 'цена старого стока', new: 'цена нового стока', mixed: 'смешанные партии (FIFO)' },
    now: 'сейчас {{value}}',
    nowCostHint: 'Себестоимость по текущему прайсу отличается от снимка',
    manualPriceHint: 'Ручная цена; очистите поле, чтобы вернуть расчётную {{value}}',
    minResaleHint: 'Минимальная цена перепродажи: {{value}}',
    costsTitle: 'Прямые расходы',
    costsSub: 'Оценка по тарифам (Настройки → Расходы и согласования): самовывоз за рейс, доставка за CBM, установка за единицу. Впишите сумму в «План», чтобы переопределить; «Факт» вносится после исполнения.',
    noCbm: 'Нет CBM: {{skus}} — доставку и самовывоз оценить нельзя',
    colCost: 'Расход',
    basis: 'Основание',
    plan: 'План',
    actual: 'Факт',
    delta: 'Δ',
    cost: { pickup: 'Самовывоз со склада партнёра', delivery: 'Доставка клиенту', installation: 'Установка', other: 'Прочее' },
    manualOverride: 'ручная оценка',
    deliveryBasis: '{{cbm}} м³ × {{rate}} AED, минимум {{min}}',
    otherHint: 'парковка, подъём, ночная работа — вручную',
    resetEstimateHint: 'Очистите поле, чтобы вернуть оценку по тарифу',
    overrideHint: 'Впишите сумму, чтобы переопределить оценку по тарифу',
    actualHint: 'Фактическая сумма после исполнения (счёт перевозчика, табель монтажников)',
    directCosts: 'Прямые расходы',
    contribution: 'Вклад после прямых расходов',
    contributionPct: 'Вклад, %',
    contributionActual: 'Вклад (факт)',
    approvalTitle: 'Согласование',
    approvalNotNeeded: 'Маржа и вклад выше порогов — согласование не требуется.',
    approvalNeeded: {
      below_min: 'Товарная маржа или вклад ниже порога. Отправка КП и перевод в «Выиграна» заблокированы до согласования.',
      loss: 'Вклад после прямых расходов отрицательный — сделка в убыток. Согласовать может только сотрудник с правом согласования убытка.',
    },
    approvalOk: 'Согласовано для этой версии.',
    approvalPending: 'Запросил {{who}} — ждёт решения.',
    approved: 'Согласовано',
    rejected: 'Отклонено',
    approve: 'Согласовать',
    reject: 'Отклонить',
    whoApproves: { below_min: 'Согласуют: admin или сотрудник с флагом согласования маржи.', loss: 'Согласует: сотрудник с флагом согласования убытка (по умолчанию — Председатель Совета директоров).' },
    reasonPlaceholder: 'Причина (например, стратегический клиент)',
    approvalRequested: 'Запрос на согласование отправлен',
    requestApproval: 'Запросить согласование',
    level: { below_min: 'ниже порога', loss: 'убыток' },
    approvalStatus: { Pending: 'ожидает', Approved: 'согласовано', Rejected: 'отклонено', Invalidated: 'сброшено изменением' },
    poLater: 'Заказы поставщикам создаются из подтверждённой спецификации на этапе 1.5. Разбивка по партнёрам показана здесь, чтобы суммы можно было проверить уже сейчас.',
  },
  costs: {
    saved: 'Расходы и согласования сохранены',
    title: 'Расходы и согласования',
    sub: 'Тарифы для оценки прямых расходов, пороги согласования и правила наценок по категории или партнёру. Действуют для каждого нового расчёта; снимки отправленных КП не меняются.',
    thresholdsTitle: 'Пороги согласования',
    thresholdsSub: 'Ниже этих значений спецификацию нельзя отправить клиенту или выиграть без согласования.',
    minMargin: 'Минимальная товарная маржа',
    minContribution: 'Минимальный вклад после прямых расходов',
    whoApproves: 'Ниже порога при вкладе ≥ 0 — admin или пользователь с флагом согласования маржи. Вклад отрицательный — только пользователь с флагом согласования убытка (Настройки → Пользователи).',
    ratesTitle: 'Тарифы самовывоза и доставки',
    ratesSub: 'Самовывоз: рейсов = ⌈CBM строк партнёра / вместимость машины⌉ × ставка. Доставка: CBM спецификации × ставка, но не меньше минимума.',
    pickupTrip: 'Самовывоз, AED за рейс',
    vehicleCbm: 'Вместимость машины, CBM',
    deliveryCbm: 'Доставка, AED за CBM',
    deliveryMin: 'Минимум доставки, AED',
    installTitle: 'Установка за единицу',
    installSub: 'AED за единицу по категории; категории без тарифа не монтируются.',
    addRow: 'Добавить',
    rulesTitle: 'Правила наценок',
    rulesSub: 'Переопределяют наценку по умолчанию для категории, партнёра или пары партнёр + категория.',
    scope: { category: 'Категория', partner: 'Партнёр', partner_category: 'Партнёр + категория' },
    noRules: 'Правил нет — действует наценка партнёра или рабочего пространства.',
    rulesOrder: 'Приоритет: наценка товара → партнёр + категория → партнёр → категория → наценка партнёра → по умолчанию.',
  },
};
